import ShipmentDetails from "./ShipmentDetails";

export default ShipmentDetails;
